import { FormEvent, MouseEvent } from 'react';
import { Button, ButtonGroup, DropdownButton, FormControl, InputGroup, MenuItem, Well } from 'react-bootstrap';
import { FormWrapper } from './styles';

interface IProps {
    alias: string,
    firstName: string,
    lastName: string,
    email: string,
    startDate?: string,
    endDate?: string,
    statusList: string[],
    typeList: string[],
    voucherType: string,
    transplanted: boolean,
    onFieldChange: (field: string, value: any) => void,
    onSearch: () => void
}

const Search = (props: IProps) => {
    const handleFieldChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        props.onFieldChange(e.currentTarget.name, e.currentTarget.value);
    };

    const handleStatusChange = (e: MouseEvent<Button & HTMLButtonElement>) => {
        let value = e.currentTarget.value;

        let newStatusList = [...props.statusList];

        if (props.statusList.indexOf(value) >= 0) {
            newStatusList = props.statusList.filter(s => s != value);
        } else {
            newStatusList.push(value);
        }

        props.onFieldChange('statusList', newStatusList);
    };

    const handleTypeChange = (e: MouseEvent<Button & HTMLButtonElement>) => {
        let value = e.currentTarget.value;

        let newTypeList = [...props.typeList];

        if (props.typeList.indexOf(value) >= 0) {
            newTypeList = props.typeList.filter(s => s != value);
        } else {
            newTypeList.push(value);
        }

        props.onFieldChange('typeList', newTypeList);
    };

    const handleVoucherChange = (e: MouseEvent<Button & HTMLButtonElement>) => {
        props.onFieldChange('voucherType', e.currentTarget.value);
    }

    const handleSubmit = (e: FormEvent<any>) => {
        e.preventDefault();
        e.stopPropagation();

        props.onSearch();
    };

    const { alias, firstName, lastName, email, statusList, typeList, voucherType } = props;

    return (
        <Well bsSize='sm'>
            <h4>SEARCH</h4>
            <FormWrapper horizontal onSubmit={handleSubmit}>
                <div style={{ display: 'flex', marginBottom: 10 }}>
                    <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                        <label style={{ marginRight: 5 }}>Alias:</label>
                        <FormControl
                            name='alias'
                            value={alias}
                            onChange={handleFieldChange} />
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                        <label style={{ marginRight: 5 }}>First&nbsp;Name:</label>
                        <FormControl
                            name='firstName'
                            value={firstName}
                            onChange={handleFieldChange} />
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                        <label style={{ marginRight: 5 }}>Last&nbsp;Name:</label>
                        <FormControl
                            name='lastName'
                            value={lastName}
                            onChange={handleFieldChange} />
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <label style={{ marginRight: 5 }}>Email:</label>
                        <FormControl
                            name='email'
                            value={email}
                            onChange={handleFieldChange} />
                    </div>
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 0 }}>
                    <div style={{ display: 'flex' }}>
                        {props.transplanted == false && (
                            <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                                <label style={{ marginRight: 5 }}>Statuses:</label>
                                <ButtonGroup>
                                    <Button value='active' className={statusList.indexOf('active') >= 0 ? 'btn-primary' : 'btn'} onClick={handleStatusChange}>Active</Button>
                                    <Button value='inactive' className={statusList.indexOf('inactive') >= 0 ? 'btn-primary' : 'btn'} onClick={handleStatusChange}>Inactive</Button>
                                    <Button value='pending' className={statusList.indexOf('pending') >= 0 ? 'btn-primary' : 'btn'} onClick={handleStatusChange}>Pending</Button>
                                </ButtonGroup>
                            </div>
                        )}

                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <label style={{ marginRight: 5 }}>Type:</label>
                            <InputGroup>
                                <InputGroup.Button>
                                    <Button value='direct' style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }} className={typeList.indexOf('direct') >= 0 ? 'btn-primary' : 'btn'} onClick={handleTypeChange}>Direct</Button>
                                </InputGroup.Button>
                                <InputGroup.Button>
                                    <Button value='paired' style={{ borderRadius: 0 }} className={typeList.indexOf('paired') >= 0 ? 'btn-primary' : 'btn'} onClick={handleTypeChange}>Paired</Button>
                                </InputGroup.Button>
                                <InputGroup.Button>
                                    <Button value='voucher' style={{ borderRadius: 0 }} className={typeList.indexOf('voucher') >= 0 ? 'btn-primary' : 'btn'} onClick={handleTypeChange}>Voucher</Button>
                                </InputGroup.Button>
                                <InputGroup.Button>
                                    <Button value='wlp' style={{ borderRadius: 0 }} className={typeList.indexOf('wlp') >= 0 ? 'btn-primary' : 'btn'} onClick={handleTypeChange}>WLP</Button>
                                </InputGroup.Button>
                                <InputGroup.Button>
                                    <Button value='krc' style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }} className={typeList.indexOf('krc') >= 0 ? 'btn-primary' : 'btn'} onClick={handleTypeChange}>KRC</Button>
                                </InputGroup.Button>
                            </InputGroup>
                        </div>

                        {typeList.indexOf('voucher') >= 0 && (
                            <div style={{ display: 'flex', alignItems: 'center', marginLeft: 10 }}>
                                <label style={{ marginRight: 5 }}>Voucher Type:</label>
                                <ButtonGroup>
                                    <Button value='' className={voucherType == '' ? 'btn-primary' : 'btn'} onClick={handleVoucherChange}>ALL</Button>
                                    <Button value='sv' className={voucherType == 'sv' ? 'btn-primary' : 'btn'} onClick={handleVoucherChange}>SV</Button>
                                    <Button value='fv' className={voucherType == 'fv' ? 'btn-primary' : 'btn'} onClick={handleVoucherChange}>FV</Button>
                                </ButtonGroup>
                            </div>
                        )}

                        {props.transplanted && (
                            <div style={{ display: 'flex', alignItems: 'center', marginLeft: 10 }}>
                                <label style={{ marginRight: 5 }}>Transplanted Between:</label>
                                <div>
                                    <FormControl
                                        type='date'
                                        name='startDate'
                                        value={props.startDate}
                                        onChange={handleFieldChange} />
                                </div>
                                <div>&nbsp;and&nbsp;</div>
                                <div>
                                    <FormControl
                                        type='date'
                                        name='endDate'
                                        value={props.endDate}
                                        onChange={handleFieldChange} />
                                </div>
                            </div>
                        )}
                    </div>

                    <div style={{ flexBasis: '150px' }}>
                        <Button bsStyle='primary' type='submit' block>Search</Button>
                    </div>
                </div>
            </FormWrapper>
        </Well>
    );
}

export default Search;